


import React from 'react';

import ReactDOM from 'react-dom';
import { Dialog } from 'element-react';
import { Button,Drawer } from '@jd/find-react';
 

import KeeVue from '../base/KeeVue.js'
import FeasComponents from './FeasComponents.js'
import FsResizers from './FsResizers.js'
import FeasPage from './FeasPage.js'
import FsView from './FsView.js'
import $ from 'jquery';



export default class FsRightDrawer extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {
				id: this.getRandString(),
				topWin: {
				},
				rightMenu: { },
				rightDetail: { },
				bottomDetail: { },
				active:false,
				content:null,
				 
			};

}

componentDidMount(){
			var that = this;
			this.registComponent(); 
			this.onEvent("showRightDrawer",(content)=>{
				this.state.active = true;
				this.state.content = content;
				this.refresh();
			})
		}

			 

  render(){
  return(

<div style={{width:' 100%',height:' 100%'}} >

    
	
			<Drawer
	           title="页面组件JSON配置"
			   mask={false}
			   maskClosable = {false}
	          placement={'right'}
	          closable={true}
	          onClose={()=>{this.state.active=false;this.refresh();}}
	          visible={this.state.active===true}
	          key={'right'}
			  width={'28%'}>
			{
				this.state.active===true&& this.state.content
				   
				 
			}
	          
	        </Drawer>
			
	
   

	</div>
  );}
 }


